import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Constants from '../../services/Constants';

class EmployeeMeetingNotesRouter extends Component {
  onStrategyEsgDei = ({ match }, documentView, url) => {
    const url1 = `${url}/meetingnotes/${match.params.investmentFirm}/investmentFirm`;
    const vp = {
      investmentFirm: match.params.investmentFirm,
      documentView,
      managerUrl: url1,
      selectedTab: Constants.CR_MEETING_NOTES_VIEW,
    };
    return this.props.withMain(Constants.CONSULTING_RESOURCES_VIEW, vp);
  };

  onInvestmentFirm = ({ match }, documentView, url) => {
    const url1 = `${url}/meetingnotes/${match.params.investmentFirm}/investmentFirm`;
    const vp = {
      investmentFirm: match.params.investmentFirm,
      documentView,
      managerUrl: url1,
      selectedTab: Constants.CR_MEETING_NOTES_VIEW,
    };
    return this.props.withMain(Constants.CONSULTING_RESOURCES_VIEW, vp);
  };

  onInvestmentFirmStrategy = ({ match }, documentView, url) => {
    const url1 = `${url}/meetingnotes/${match.params.investmentFirm}/investmentFirm`;
    const vp = {
      investmentFirm: match.params.investmentFirm,
      strategyName: match.params.strategyName,
      documentView,
      managerUrl: url1,
      selectedTab: Constants.CR_MEETING_NOTES_VIEW,
    };
    return this.props.withMain(Constants.CONSULTING_RESOURCES_VIEW, vp);
  };

  onConsultingResources = selectedTab => {
    const vp = { investmentFirm: null, selectedTab: selectedTab };
    return this.props.withMain(Constants.CONSULTING_RESOURCES_VIEW, vp);
  };

  resetSelectedPlan = () => {
    const { ui } = this.props;
    if (ui.selectedPlan) {
      ui.selectedPlan = null;
      this.setState({ ui });
    }
  };

  render() {
    this.resetSelectedPlan();
    const { match } = this.props;

    const viewParams = {
      baseURL: match.url,
    };

    return (
      <Switch>
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/esg-opinion`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_ESG,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/dei-opinion`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_DEI,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/nepc`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_NEPC_NARRATIVES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/meetingnotes`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_RESEARCH,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/dd`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_DD_EVENTS,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/evest`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_EVEST_NARRATIVES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName/activities`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_MANAGER_ACTIVITIES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategy/:strategyName`}
          render={props =>
            this.onInvestmentFirmStrategy(
              props,
              Constants.FPL_MANAGER_ACTIVITIES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/strategies`}
          render={props =>
            this.onInvestmentFirm(
              props,
              Constants.PLAN_MANAGER_STRATEGIES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/dd`}
          render={props =>
            this.onInvestmentFirm(
              props,
              Constants.PLAN_MANAGER_DD_EVENTS,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/evest`}
          render={props =>
            this.onInvestmentFirm(
              props,
              Constants.PLAN_MANAGER_EVEST_NARRATIVES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm/activities`}
          render={props =>
            this.onInvestmentFirm(
              props,
              Constants.EMPLOYEE_MANAGER_ACTIVITIES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/:investmentFirm/investmentFirm`}
          render={props =>
            this.onInvestmentFirm(
              props,
              Constants.PLAN_MANAGER_STRATEGIES,
              viewParams.baseURL
            )
          }
        />
        <Route
          path={`${match.url}/meetingnotes/`}
          render={props =>
            this.onConsultingResources(Constants.CR_MEETING_NOTES_VIEW)
          }
        />
      </Switch>
    );
  }
}

EmployeeMeetingNotesRouter.propTypes = {
  match: PropTypes.object.isRequired,
  onInvestmentFirm: PropTypes.func,
  withMain: PropTypes.func,
  ui: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    ui: state.ui,
  };
};

export default connect(mapStateToProps, {})(EmployeeMeetingNotesRouter);
